/**
 * **Recharge la page quand un morceau de l'app manque** (15/10).
 *
 * Les fichiers de webpack portent leur empreinte. Un onglet ouvert pendant un
 * déploiement garde l'ancien `index.html` et demande des fichiers que le
 * nouveau conteneur n'a plus : « Loading chunk … failed ». Plutôt qu'un écran
 * blanc, on recharge une fois — le navigateur reprend alors la page courante
 * et ses fichiers. Au plus une fois par minute, pour ne pas boucler si le
 * réseau est vraiment coupé.
 */
const STORAGE_KEY = 'luckysit:chunk-reload-at'
const MIN_INTERVAL_MS = 60_000
const CHUNK_FAILURE = /Loading (CSS )?chunk|ChunkLoadError/

const isChunkFailure = (reason: unknown): boolean => {
    const message = String((reason as { message?: unknown })?.message ?? reason ?? '')
    return CHUNK_FAILURE.test(message)
}

const reloadOnce = (): void => {
    let lastReload = 0
    try {
        lastReload = Number(window.sessionStorage.getItem(STORAGE_KEY) || 0)
    } catch {
        // Stockage indisponible : on recharge quand même, une fois par chargement.
    }
    if (Date.now() - lastReload < MIN_INTERVAL_MS) return
    try {
        window.sessionStorage.setItem(STORAGE_KEY, String(Date.now()))
    } catch {
        // idem
    }
    window.location.reload()
}

export const installChunkReload = (): void => {
    window.addEventListener('error', (event) => {
        if (isChunkFailure(event.error ?? event.message)) reloadOnce()
    })
    window.addEventListener('unhandledrejection', (event) => {
        if (isChunkFailure(event.reason)) reloadOnce()
    })
}
